import axios from "@/services/axios";
import { getPaginationValues } from "@/utils/pagination-helper";
import { AxiosResponse } from "axios";
import { computed, reactive } from "vue";
import ResearchEquipmentDetailDto from "./research-equipment-detail-dto";

interface ResearchEquipmentFilterRequest {
  organizationIds?: string[];
  equipmentResearchOrientationTypeIds?: string[];
  equipmentCriteriaIds?: string[];
  equipmentLifeCycleStatusIds?: string[];

  equipmentAccessMethodIds?: string[];
  equipmentAccessTypeIds?: string[];
  equipmentAccessPurposeIds?: string[];

  equipmentUniLeedTypeIds?: string[];
  equipmentUniLeedOrderTypeIds?: string[];
  equipmentUniLeedClassTypeIds?: string[];
}

const state = reactive({
  selectedResearchEquipment: {} as any,
  compareResearchEquipment: {} as any,
  data: [],
  compareList: [] as Array<any>,
  groupFiltered: [] as Array<ResearchEquipmentDetailDto>,
});

export default function ResearchEquipmentRepositoryAPI() {
  async function detail(id: string): Promise<ResearchEquipmentDetailDto> {
    return await axios
      .get(`api/v1/ResearchEquipment/${id}/detail`)
      .then((response: AxiosResponse) => {
        return response.data;
      });
  }

  async function detailAdmin(id: string): Promise<ResearchEquipmentDetailDto> {
    return await axios
      .get(`api/v1/Admin/ResearchEquipment/${id}/detail`)
      .then((response: AxiosResponse) => {
        return response.data;
      });
  }

  const addToCompare = (item: any): void => {
    let alreadyAdded = false;
    state.compareList.forEach((element) => {
      if (element.id == item.id) {
        alreadyAdded = true;
      }
    });
    if (!alreadyAdded) {
      if (state.compareList.length > 10) {
        state.compareList.pop();
        state.compareList.unshift(item);
      } else {
        state.compareList.push(item);
      }
    }
  };

  const removeFromCompare = (item: any): void => {
    state.compareList.forEach((value, index) => {
      if (value == item) state.compareList.splice(index, 1);
    });
  };

  const setResearchEquipment = (selected: any): void => {
    detail(selected.id).then((item) => {
      state.selectedResearchEquipment = item;
    });
  };

  const setResearchEquipmentAdmin = (selected: any): void => {
    detailAdmin(selected.id).then((item) => {
      state.selectedResearchEquipment = item;
    });
  };

  const setResearchEquipmentCompare = (selected: any): void => {
    detail(selected.id).then((item) => {
      state.compareResearchEquipment = item;
    });
  };

  const setResearchEquipmentFiltered = (selected: any): void => {
    state.groupFiltered = selected;
  };

  const addResearchEquipmentFiltered = (
    selected: ResearchEquipmentDetailDto
  ): void => {
    state.groupFiltered.push(selected);
  };

  const removeResearchEquipmentFiltered = (selected: any): void => {
    state.groupFiltered = state.groupFiltered.filter(
      (item: any) => item.id !== selected.id
    );
  };

  const clearResearchEquipmentFiltered = (): void => {
    state.groupFiltered = [];
  };

  const loadItems = (data: any): void => {
    axios
      .get(
        `api/v1/ResearchEquipment?PageNumber=${data.lazyParams.page}&PageSize=${data.lazyParams.rows}&Keyword=${data.keywords}`
      )
      .then((response: any) => {
        data.lazyParams = getPaginationValues(response.headers);
        data.researchEquipmentGroup = response.data;
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  const loadItem = (data: any, id: string): void => {
    axios
      .post(
        `api/v1/ResearchEquipment/filter?PageNumber=${data.lazyParams.page}&PageSize=${data.lazyParams.rows}&Keyword=${data.keywords}`,
        {
          organizationIds: [id],
          showAll: true,
        } as ResearchEquipmentFilterRequest
      )
      .then((response: any) => {
        data.lazyParams = getPaginationValues(response.headers);
        data.researchEquipmentGroup = response.data;
        data.dataLoading = false;
      })
      .catch(() => (data.dataLoading = false));
  };

  return {
    getResearchEquipmentGroup: computed(() => state.data),
    getCompareList: computed(() => state.compareList),
    addToCompare,
    removeFromCompare,
    setResearchEquipment,
    setResearchEquipmentAdmin,
    getSelectedResearchEquipment: computed(
      () => state.selectedResearchEquipment
    ),
    setResearchEquipmentCompare,
    getResearchEquipmentCompare: computed(() => state.compareResearchEquipment),
    addResearchEquipmentFiltered,
    removeResearchEquipmentFiltered,
    setResearchEquipmentFiltered,
    clearResearchEquipmentFiltered,
    getResearchEquipmentFiltered: computed(() => state.groupFiltered),
    loadItem,
    loadItems,
  };
}
